export enum LOCATION_EVENTS {
  "FROM" = "from",
  "FROM_VIA" = "from-via",
  "TO" = "mid-stop",
  "RETURN_FROM" = "restart-mid",
  "TO_VIA" = "to-via",
  "RETURN_TO" = "to"
}

export enum USER_STATUS {
  "ACTIVE" = "active",
  "PENDING" = "pending",
  "EXPIRED" = "expired"
}

export enum SEARCH_TYPE {
  "TEXT" = "text",
  "DATE" = "date",
  "STATUS" = "status",
  "ORGANIZATION" = "organization",
  "INVOICED_TRIP" = "invoiced_trip"
}

export enum NETWORK_REQUEST_STATUS {
  WAITING = "waiting",
  ACCEPTED = "accepted",
  REJECTED = "rejected",
  CANCELLED_BY_SYSTEM = "cancelled_by_system",
  CANCELLED_BY_HOST = "cancelled_by_host",
  CANCEL_REQUEST = "cancel_request",
  CANCELLED = "cancelled",
  CANCELLED_AFTER_ACCEPTANCE = "cancelled_after_acceptance"
}

export enum NETWORK_TRIP_STATUS {
  NEW = "new",
  PLANNING = "planning",
  PENDING = "pending",
  READY = "ready",
  RUNNING = "running",
  CLOSED = "closed"
}

export enum NETWORK_TRIP_ACTIVE_STATUS {
  DRIVER_ACCEPTED = "driver_accepted",
  DRIVER_REJECTED = "driver_rejected",
  STARTED = "started",
  ARRIVED_TO_CUSTOMER = "arrived_to_customer",
  PICKED_UP_CUSTOMER = "picked_up_customer",
  REACHED_AT_DESTINATION = "reached_at_destination",
  REACHED_AT_MID_POINT = "reached_at_mid_point",
  START_FROM_MID_POINT = "start_from_mid_point",
  ABORTED = "aborted",
  CANCELLED = "cancelled"
}

export const TRIP_TYPE = {
  REQUEST: "new",
  ACTIVE: "active",
  CLOSED: "finished",
  INVOICED: "invoiced",
  ALL: "all"
};

export enum ROLE {
  ADMIN = "admin",
  DRIVER = "driver",
  MASTER_ADMIN = "master-admin"
}

export enum REDIRECTION_ENUM {
  LINK_EXPIRED = "link-expired",
  PROFILE_CREATED = "profile-created",
  DEFAULT = "default",
  INVITATION_VERIFIED = "invitation-verified"
}

export const enum REQUEST_TRIP_ACTIONS {
  ACCEPT = "accept",
  REJECT = "reject",
  BULK_ACCEPT = "bulk_accept",
  BULK_REJECT = "bulk_reject"
}

export const enum ACTIVE_TRIP_ACTIONS {
  START_TRIP = "start-trip",
  CLOSE_TRIP = "direct-close-trip",
  APPLESS = "appless",
  DRIVER_ASSIGN = "driver-assign",
  VEHICLE_ASSIGN = "vehicle-assign",
  DRIVER_BULK_ASSIGN = "driver-bulk-assign",
  VEHICLE_BULK_ASSIGN = "vehicle-bulk-assign",
  FINALIZE_TRIP = "finalize-trip"
}

export const enum CLOSED_TRIP_ACTIONS {
  SEND_CLAIM_TO_HOST = "submit-claim",
  SET_READY_TO_INVOICE = "set-ready-to-invoice",
  REDIRECT_TO_FINALIZE = "redirect-to-finalize"
}

export const enum ACTION_MODE {
  GET_SINGLE,
  GET_LIST,
  ADD,
  EDIT,
  QUICK_ASSIGN,
  RE_INVITE,
  DELETE
}

export enum VERIFICATION_TYPE {
  COMPANY_INVITATION = "company-invitation",
  EMPLOYEE_INVITATION = "employee-invitation",
  COMPANY_AFFILIATION = "company-affiliation"
}

export enum TRIP_STATUS_ENUM {
  PLANNING = "planning",
  PENDING = "pending",
  "READY" = "ready",
  RUNNING = "running",
  CLOSED = "closed"
}

export enum CTA_LINK {
  HELP = "https://busnetwork.zendesk.com/hc/en-us",
  CONTACT = "https://busnetwork.zendesk.com/hc/en-us",
  ANDROID_APP = "https://play.google.com/store/apps/details?id=app.ferdia.busnetwork_driver",
  IOS_APP = "https://apps.apple.com/app/ferdia-busnetwork-driver/id6478439271"
}

export enum DASHBOARD_URL_HASH_IDS {
  NEED_RESPONSE = "need-response"
}

export const MAX_BULK_SELECTION_ALLOWED = 10;

export enum FILTER_PARENT_KEY {
  REQUEST_LIST,
  ACTIVE_TRIP_LIST,
  CLOSED_TRIP_LIST,
  INVOICED_LIST,
  ALL_TRIPS_LIST
}

export enum DEVIATION_CONTEXT {
  FROM_ARRIVED = "from_arrived",
  FROM_DEPARTED = "from_departed",
  TO_ARRIVED = "to_arrived"
}

export enum CLAIM_STATUS {
  DRAFT = "draft",
  PENDING = "pending",
  APPROVED = "approved",
  DECLINED = "declined"
}

export enum INVOICE_STATUS {
  READY = "ready",
  EXPORTED = "exported"
}

export enum TRIP_LIST_VIEW {
  REQUEST = "request",
  ACTIVE = "active",
  CLOSED = "closed"
}

export const enum INVOICE_TRIP_ACTIONS {
  EXPORT_READY_INVOICE = "ready_to_invoice",
  EXPORT_ALL_INVOICE = "all"
}

export const enum BULK_ACTION_TYPE {
  DRIVER = "driver",
  VEHICLE = "vehicle"
}
